import React from 'react';
import { connect } from 'react-redux'

import Bodycomponent from './Bodycomponent'
import Footercomponent from './Footercomponent';
import Headercomponent from './Headercomponent'

const Main = (props) => {
    return (
<React.Fragment>
        
                <Headercomponent ></Headercomponent>
             
          
            <Bodycomponent ></Bodycomponent>
   
           
            
            <Footercomponent></Footercomponent>
            </React.Fragment>
        


    )
}
const mapstatestoprops = (state) => {
    return {
        currenttab: state.currenttab.currenttab
    }

}
export default connect(mapstatestoprops)(Main)